import { useEffect, useState } from "react";
import { X, Send, UserCheck } from "lucide-react";
import api from "@/lib/api";

// Tradie with workers on file: choose who's actually turning up before the application goes to the builder.
export default function PickAttendeeModal({ open, dates = [], busy, onSubmit, onClose }) {
  const [people, setPeople] = useState(null);
  const [who, setWho] = useState("");
  useEffect(() => {
    if (!open) return;
    api.get("/crew/free", { params: { dates: dates.join(",") } }).then((r) => {
      setPeople(r.data || []);
      const me = (r.data || []).find((p) => p.me && !p.busy_dates?.length);
      setWho(me ? me.id : "");
    }).catch(() => setPeople([]));
  }, [open, dates.join(",")]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[70] bg-black/80 flex items-end sm:items-center justify-center p-0 sm:p-4" data-testid="pick-attendee-modal">
      <div className="w-full max-w-md bg-[#111] border border-white/15 p-6 relative">
        <button onClick={onClose} className="absolute top-3 right-3 text-red-500 hover:text-red-400" aria-label="Close" data-testid="pick-attendee-close"><X className="w-5 h-5" /></button>
        <div className="flex items-center gap-2 font-bold uppercase tracking-widest text-xs" style={{ color: "#FF6A00" }}><UserCheck className="w-4 h-4" /> Who's turning up?</div>
        <p className="mt-2 text-sm" style={{ color: "#E4E4E7" }}>The builder sees who's applying, so pick the person who'll actually be on site.</p>
        <div className="mt-4 space-y-2" data-testid="pick-attendee-list">
          {people === null && <div className="h-10 bg-white/5 animate-pulse" />}
          {(people || []).map((p) => {
            const blocked = p.busy_dates?.length > 0;
            return (
              <label key={p.id} className={`flex items-center gap-3 border px-3 py-2.5 cursor-pointer ${who === p.id ? "border-[#FF6A00]" : "border-white/15"} ${blocked ? "opacity-50 cursor-not-allowed" : ""}`} data-testid={`pick-attendee-${p.id}`}>
                <input type="radio" name="attendee" value={p.id} checked={who === p.id} disabled={blocked} onChange={() => setWho(p.id)} className="accent-[#FF6A00]" />
                <span className="flex-1 text-sm" style={{ color: "#fff" }}>{p.name}{p.me ? " (you)" : ""}{p.trade ? <span style={{ color: "#A1A1AA" }}> · {p.trade}</span> : null}</span>
                {blocked && <span className="text-[10px] uppercase tracking-widest text-red-500 font-bold">Booked that day</span>}
              </label>
            );
          })}
        </div>
        <button onClick={() => onSubmit(who)} disabled={!who || busy}
          className="mt-4 w-full inline-flex items-center justify-center gap-2 px-3 py-2.5 bg-[#FF6A00] text-black text-xs font-black uppercase tracking-widest hover:bg-white disabled:opacity-50" data-testid="pick-attendee-submit">
          <Send className="w-4 h-4" /> {busy ? "Applying…" : "Apply with this person"}
        </button>
        <button onClick={onClose} style={{ color: "#D4D4D8" }} className="mt-3 w-full px-3 py-2 border border-white/20 text-xs font-bold uppercase tracking-widest hover:border-white" data-testid="pick-attendee-cancel">Cancel</button>
      </div>
    </div>
  );
}
